import { onUnmounted, toValue, watch, type MaybeRefOrGetter } from 'vue'
import { lockBodyScroll, unlockBodyScroll } from '@/utils/body-scroll-lock'

/**
 * Lock page scroll while `active` is true (modals, drawers).
 * Nested callers are reference-counted.
 */
export function useBodyScrollLock(active: MaybeRefOrGetter<boolean>): void {
  let held = false

  function sync(on: boolean) {
    if (on && !held) {
      lockBodyScroll()
      held = true
    } else if (!on && held) {
      unlockBodyScroll()
      held = false
    }
  }

  watch(
    () => toValue(active),
    (on) => sync(Boolean(on)),
    { immediate: true },
  )

  onUnmounted(() => {
    if (held) {
      unlockBodyScroll()
      held = false
    }
  })
}
